// extracted by mini-css-extract-plugin
module.exports = {"container":"_6GdzUtrWse2jbtsttJarc","title":"_3kHks6SjAHQ0DrankwQ4Z- appSubtitle","category":"GyzC8Eaw4VfFCwW5son1L content buttonShadow","name":"qGJ5veit2cIzzEJ4T7x30 appTitle"};